import React from 'react';

const PauseIcons = () => {
  return (
    <>
      <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1V11.5M7 1V11.5" stroke="#044E97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </>
  );
};

export default PauseIcons;
